<template>
  <FormationDetailLayout
    lesson="Formation taxi pratique seule"
    back-item="formation-taxi"
    :hero-image="heroImage"
    hero-alt="hill-timelaps"
    hero-eyebrow="Préparation examen pratique taxi"
    hero-title="TAXI PRATIQUE SEULE"
    :hero-stats="heroStats"
  >
    <template #main>
      <article class="formation-section formation-section--intro">
        <h2>Taxi examen pratique seul</h2>

        <div class="formation-flow">
          <p>
            Découvrez notre <strong>formation pratique seule vtc</strong> pour
            l'<strong>examen T3P</strong> (<strong
              >Transport Public Particulier de Personnes</strong
            >), spécialement conçue pour les <strong>conducteurs VTC</strong>.
            Notre <strong>formation pratique vtc</strong> vise à vous préparer
            de manière intensive à réussir l'<strong
              >examen pratique T3P</strong
            >
            et à développer les compétences nécessaires pour assurer la sécurité
            des passagers et des autres usagers de la route tout en offrant un
            service de qualité en tant que <strong>chauffeur VTC</strong>.
          </p>

          <p>
            Notre programme de formation comprend trois séances de conduite
            dédiées, spécifiquement adaptées aux exigences de l'<strong
              >épreuve pratique de l'examen T3P</strong
            >
            pour les <strong>conducteurs VTC</strong>. Vous serez encadré par
            nos formateurs expérimentés, qui vous guideront dans l'apprentissage
            des techniques de conduite spécifiques au transport de personnes.
            Vous vous familiariserez avec les manœuvres requises, les règles de
            sécurité et les bonnes pratiques pour assurer une expérience de
            voyage optimale pour vos passagers.
          </p>

          <p>
            Afin de vous offrir un environnement réaliste, nous mettons à votre
            disposition un véhicule conforme aux normes de l'<strong
              >examen T3P</strong
            >
            pour les <strong>conducteurs VTC</strong>. Vous pourrez ainsi vous
            entraîner dans des conditions similaires à celles de l'épreuve, en
            vous confrontant à différentes situations de conduite et en
            perfectionnant vos compétences de gestion du véhicule et de réaction
            aux situations routières.
          </p>

          <p>
            En choisissant notre
            <strong>formation pratique pour les conducteurs VTC</strong>, vous
            bénéficiez d'un accompagnement personnalisé et de conseils avisés
            pour améliorer votre conduite et développer vos compétences
            spécifiques à l'<strong>activité de VTC</strong>. Notre équipe
            pédagogique expérimentée est là pour répondre à toutes vos questions
            et vous fournir les connaissances nécessaires pour réussir
            brillamment l'<strong>épreuve pratique de l'examen T3P</strong>.
          </p>

          <p>
            Ne laissez rien au hasard dans votre préparation. Rejoignez notre
            <strong>formation pratique pour les conducteurs VTC</strong> et
            augmentez vos chances de réussite à l'<strong>examen T3P</strong>.
            Avec un investissement de seulement 390€, vous accédez à un
            programme de qualité, axé sur la pratique et spécialement conçu pour
            vous aider à atteindre vos objectifs en tant que
            <strong>chauffeur VTC</strong>.
          </p>
        </div>
      </article>

      <ExamPrerequisitesCard mode="taxi" />
    </template>
  </FormationDetailLayout>
</template>

<script>
import ExamPrerequisitesCard from "@/components/formations/ExamPrerequisitesCard.vue";
import FormationDetailLayout from "@/components/formations/FormationDetailLayout.vue";
import { useMeta } from "vue-meta";

const heroImage = require("@/assets/pictures/examen-pratique-taxi.webp");
const heroStats = [
  { label: "Prix", value: "390€" },
  { label: "Durée", value: "3 séances de conduite" },
  { label: "Voiture de prêt", value: "pour l'examen" },
];

export default {
  name: "TaxiPratiqueSeule",
  components: { ExamPrerequisitesCard, FormationDetailLayout },
  setup() {
    useMeta({
      title: "examen pratique seule taxi",
      description: [
        {
          content:
            "Préparez-vous à l'examen pratique Taxi avec notre formation complète. Évaluez vos compétences de conduite en circulation, la sécurité des passagers et des autres usagers de la route, ainsi que votre capacité à offrir un service client de qualité.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.institut-taxi.fr/formation-taxi-pratique-seule",
        },
      ],
    });
  },
  data() {
    return {
      heroImage,
      heroStats,
    };
  },
};
</script>
